<template>
  <div id="app" class="container">
    <b-navbar>
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img src="logo.png"/>
        </b-navbar-item>
      </template>
      <template slot="start">
        <h1 style="padding-top: 15px;">Portal da Transparência</h1>
      </template>
      <template slot="end">        
      </template>
    </b-navbar>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

